import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import DataTable from '../../components/Table/DataTable';
import SearchBox from '../../components/SearchBox/SearchBox';

import { getApiConnectKeys, createApiConnectKey, revokeApiConnectKey, removeApiConnectKey } from '../../services/apiConnectKeys';
import { showAlert } from '../../store/ducks/alert';

import { CircularProgress } from '@material-ui/core';
import { Button, InputField, Modal, Text } from '@getpingback/realeza';
import { PlusIcon, TimesCircleIcon, TrashCanIcon } from '@stash-ui/regular-icons';

const ApiConnectKeys = ({ location, match }) => {
  const dispatch = useDispatch();

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [channelUidValue, setChannelUidValue] = useState('');
  const [connectKey, setConnectKey] = useState('');

  const [isLoadingNewWarmupRule, setIsLoadingNewWarmupRule] = useState(false);

  const [apiConnectKeys, setApiConnectKeys] = useState([]);
  const [page, setPage] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [isSearching, setIsSearching] = useState(false);
  const [isOrdering, setIsOrdering] = useState(0);
  const [searchField, setSearchField] = useState({
    searchItem: '',
    search: '',
  });
  const [orderDirections, setOrderDirections] = useState({
    item: '',
    direction: '',
  });
  useEffect(() => {
    if (location.state && location.state.remount) {
      handleSubmitSearch({
        searchItem: '',
        search: '',
      });
    }
  }, [location]);

  useEffect(() => {
    let currentPage = location.search.split('=')[1] || page;
    if (match && match.params.searchItem && match.params.search) {
      handleSubmitSearch({
        searchItem: match.params.searchItem,
        search: match.params.search,
      });
    }
    displayApiConnectKeys(currentPage);
  }, [isSearching, isOrdering, page]);

  const handleSubmitSearch = searchBox => {
    setSearchField({
      ...searchField,
      searchItem: searchBox.searchItem,
      search: searchBox.search,
    });
    setIsSearching(searchBox.search);
  };

  const headers = ['id', 'channelUid', 'keyCrypted', 'keyMask', 'status', 'createdAt', 'updatedAt', 'deletedAt'];
  const SearchBoxHeaders = ['id', 'channelUid', 'keyCrypted', 'keyMask', 'status'];

  const displayApiConnectKeys = async currentPage => {
    try {
      setIsLoading(true);

      let params = { order: orderDirections.item, direction: orderDirections.direction, limit: 5 };
      if (isSearching) params = { ...searchField, ...params };
      const { data: apiConnectKeys } = await getApiConnectKeys(currentPage || page, params);

      setApiConnectKeys(apiConnectKeys.rows);
      setTotalItems(apiConnectKeys.count);
      setTotalPages(apiConnectKeys.pages);
      setPage(apiConnectKeys.page);
      setIsLoading(false);
    } catch (error) {
      dispatch(showAlert('error', error.message));
    }
  };

  const generateNewApiConnectKey = async () => {
    try {
      setIsLoadingNewWarmupRule(true);

      await createApiConnectKey(channelUidValue, connectKey);
      dispatch(showAlert('success', 'Api Connect Key added successfully'));
      setIsLoadingNewWarmupRule(false);
    } catch (error) {
      dispatch(showAlert('error', error.message));
      setIsLoadingNewWarmupRule(false);
    }
  };

  const revokeApiConnect = async id => {
    try {
      await revokeApiConnectKey(id);
      dispatch(showAlert('success', 'Api Connect Key revoked successfully'));
    } catch (error) {
      console.log(error);
      dispatch(showAlert('error', error.message));
    }
  };

  const deleteApiConnect = async id => {
    try {
      await removeApiConnectKey(id);
      dispatch(showAlert('success', 'Api Connect Key removed successfully'));
    } catch (error) {
      console.log(error);
      dispatch(showAlert('error', error.message));
    }
  };

  if (isLoading) return <CircularProgress color="inherit" className="circular-progress" />;

  return (
    <>
      <div className="users-container">
        <h1>API Connect Keys ({totalItems})</h1>

        <div className="users-right">
          <Button appearence="solid" onClick={() => setIsModalOpen(true)} leftElement={<PlusIcon />}>
            Generate new API Key
          </Button>

          <SearchBox
            date-testid="search-box"
            selectItems={SearchBoxHeaders}
            onSubmitSearch={handleSubmitSearch}
            isSearching={isSearching}
            setIsOrdering={setIsOrdering}
          />
        </div>
      </div>

      <DataTable
        useUid={true}
        head={headers}
        body={apiConnectKeys}
        action={false}
        bodyColumn={headers}
        linkPath={'api-connect-keys'}
        totalPages={totalPages}
        currentPage={page}
        orderDirections={orderDirections}
        setOrderDirections={setOrderDirections}
        setPageChange={setPage}
        setIsOrdering={setIsOrdering}
        isOrdering={isOrdering}
        customActions={[
          {
            icon: <TimesCircleIcon />,
            action: item => {
              revokeApiConnect(item.id);
            },
          },
          {
            icon: <TrashCanIcon />,
            action: item => {
              deleteApiConnect(item.id);
            },
          },
        ]}
      />

      <Modal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)}>
        <Text tag="h2" type="subtitle" size={20} weight="semibold">
          Generate new API Key
        </Text>

        <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
          <InputField
            label="Channel UID"
            value={channelUidValue}
            onChange={e => setChannelUidValue(e.target.value)}
            placeholder="Enter channel UID"
          />

          <InputField label="Key" value={connectKey} onChange={e => setConnectKey(e.target.value)} placeholder="Enter key" />
        </div>

        <Button fullWidth appearence="solid" mt="16px" isLoading={isLoadingNewWarmupRule} onClick={generateNewApiConnectKey}>
          Generate
        </Button>
      </Modal>
    </>
  );
};

export default ApiConnectKeys;
